<template>
  <div style="display: flex; flex-direction: column; height: 100%">
    <div style="flex: 1 1">
      <div style="flex: 1" class="mt-3">
        <div v-if="contact" style="display: grid" class="mx-2">
          <div style="grid-area: 1/1/1/1; justify-self: start">
            <div class="tag-container" v-if="current_contact.contact_id != 'family'">
              <v-icon v-if="isMobile && allConversations" @click="goBack()"
                style="display: inline;">mdi-arrow-left</v-icon>

              <ContactPopup
                v-if="current_contact.contact_id && (contact.ph1 || contact.ph2 || contact.ph3 || contact.email)" dense
                :contact_id="parseInt(current_contact.contact_id)" :tooltip="false" :showProfile="false" />
              <UnknownPopup v-if="current_contact.contact_id && contact.phone_num" :phoneNum="contact.phone_num"
                :dense="true" />

              <v-tooltip v-if="insurance && insurance.primary" location="bottom">
                <template v-slot:activator="{ props }">
                  <v-chip v-bind="props" size="x-small" label class="ml-1" color="blue">
                    P: {{ insurance.primary.carrierName }}
                  </v-chip>
                </template>
                Primary: {{ insurance.primary.carrierName }} (Subscriber ID: {{ insurance.primary.subscriberId || 'n/a' }})
              </v-tooltip>
              <v-tooltip v-if="insurance && insurance.secondary" location="bottom">
                <template v-slot:activator="{ props }">
                  <v-chip v-bind="props" size="x-small" label class="ml-1" color="indigo">
                    S: {{ insurance.secondary.carrierName }}
                  </v-chip>
                </template>
                Secondary: {{ insurance.secondary.carrierName }} (Subscriber ID: {{ insurance.secondary.subscriberId || 'n/a' }})
              </v-tooltip>
              <v-chip v-if="insurance && !insurance.primary && !insurance.secondary"
                size="x-small" label class="ml-1" color="grey">
                No insurance
              </v-chip>

              <v-tooltip v-if="reliability" location="bottom">
                <template v-slot:activator="{ props }">
                  <v-chip v-bind="props" size="x-small" label class="ml-1"
                    :color="reliabilityColor(reliability.label)">
                    {{ reliability.label }}
                  </v-chip>
                </template>
                {{ reliability.kept }} kept, {{ reliability.missed }} missed, {{ reliability.cancelled }} cancelled, {{ reliability.changed }} rescheduled
              </v-tooltip>

              <div class="shared-overlay" v-if="showTagPopup">
                <TagPopup v-model="showTagPopup" :tags="filteredTags" @applyTag="addTagToContact" :isTagpopup="true"
                  :enableEdit="true">
                </TagPopup>
              </div>
              <!-- Displaying List of tags for contact's -->
              <div class="d-flex flex-wrap" v-if="current_contact.contact_id && current_contact?.tag_id?.length">
                <v-menu location="bottom center">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" color="red">mdi-account-tag-outline</v-icon>
                  </template>
                  <div v-for="tagId in current_contact.tag_id" :key="tagId">
                    <template v-if="tagsHashnew[tagId]">
                      <v-tooltip :location="'bottom'" :text="tagsHashnew[tagId].tag_name" style="display : inline;">
                        <template v-slot:activator="{ props }">
                          <div v-bind="props">
                            <v-btn size="25" color="white" elevation="3" icon style="margin-top: 5px;">
                              <v-icon size="20" :color="tagsHashnew[tagId].tag_color"
                                @click="remove_TagForContact(tagId)">
                                <!-- remove tag on click -->
                                mdi-{{ tagsHashnew[tagId].tag_icon }}
                              </v-icon>
                            </v-btn>
                          </div>
                        </template>
                      </v-tooltip>
                    </template>
                  </div>
                </v-menu>
              </div>
            </div>
          </div>
          <div style="grid-area: 1/1/1/1">
            <div class="displayCenter" style="margin-top: 10px; padding: 0px;">
              <div v-if="familyMembers.length > 1 && current_contact.contact_id" class="d-flex">
                <!-- Family Member Circles -->
                <div v-for="(member, index) in familyMembers" :key="index" class="mx-1" style="position: relative;"
                  @mouseover="hoveredMember = index"
                  @mouseleave="hoveredMember = hoveredMember === index ? null : hoveredMember">
                  <div v-if="hoveredMember === index" class="tooltip-box">
                    {{ member.full_name }}
                  </div>


                  <v-avatar :size="selectedIndex === index ? '2rem' : '1.5rem'"
                    v-bind:color="getContactColor(contactsHash[member.contact_id].contact_type)" class="circle-style"
                    :class="{ 'selected-circle': selectedIndex === index, 'hovered-circle': hoveredMember === index }"
                    :style="{
                      marginLeft: selectedIndex === index ? '-5px' : '-15px',
                      marginRight: selectedIndex === index ? '5px' : '-15px'
                    }" @click="toggleSize(index); viewFamilyMember(member)" @mouseover="hoveredMember = index"
                    @mouseleave="hoveredMember = hoveredMember === index ? null : hoveredMember">
                    <span class="avatar-text">
                      {{ member.first_name.substring(0, 2).toUpperCase() }}
                    </span>
                  </v-avatar>

                  <div v-if="selectedIndex === index && hoveredMember === index" class="icon-container">
                    <div>
                      <v-icon size="15" @click="createInternalConvo" v-touch="{ start: createInternalConvo }"
                        color="primary">mdi-plus</v-icon>
                      <v-tooltip activator="parent" location="top">Create new convo on this contact</v-tooltip>
                    </div>

                    <div>
                      <v-icon style="margin-left: 5px" size="15" @click="showCommConvos"
                        v-touch="{ start: showCommConvos }" color="green">mdi-chat</v-icon>
                      <v-tooltip activator="parent" location="top">View convos on this contact</v-tooltip>
                    </div>

                    <div v-if="can_manual_tagging">
                      <v-icon size="15" @click="toggleTagPopup" v-touch="{ start: toggleTagPopup }"
                        style="margin-left: 5px" color="red">mdi-tag-plus</v-icon>
                      <v-tooltip activator="parent" location="top">Add Tag to Contact</v-tooltip>
                    </div>
                  </div>
                </div>

                <!-- ALL Circle -->
                <div class="all-circle-container" @mouseover="hoveredMember = 'all'" @mouseleave="handleAllMouseLeave"
                  @click.stop="() => { selectedIndex = null; selectedAllFamilyButton = true; viewAllFamilyConvos(); }">
                  <!-- Tooltip -->
                  <div v-if="hoveredMember == 'all'" class="tooltip-box-all">
                    All family conversations
                  </div>

                  <v-avatar :size="selectedAllFamilyButton === true ? '2rem' : '1.5rem'" color="grey darken-2"
                    class="circle-style"
                    :class="{ 'all-selected-circle': selectedAllFamilyButton === true, 'hovered-circle': hoveredMember === 'all' }">
                    <v-icon size='20'>mdi-account-group</v-icon>
                  </v-avatar>
                </div>
              </div>
              <div v-else @mouseover="openOptions" @mouseleave="closeOptions">
                <v-menu open-on-hover :close-on-content-click="false" close-delay="500" max-width="60" min-width="15"
                  max-height="25" offset-y top right offset-x style="overflow-y: hidden">
                  <template v-slot:activator="{ props }">
                    <div v-bind="props" :class="highlightedItem === 'contact' ? 'outlined rounded' : ''
                      ">
                      {{ phoneFormatTitle(contact.full_name) }}
                    </div>
                  </template>
                </v-menu>
                <div v-show="showoptions && !isUser"  @mouseenter="openOptions">
                  <div style="display: inline;" >
                    <v-icon size="15" @click="createInternalConvo" color="primary">mdi-plus</v-icon>
                    <v-tooltip activator="parent" location="top">Create new convo on this contact</v-tooltip>
                  </div>
                  <div style="display: inline;">
                    <v-icon style="margin-left: 5px" size="15" @click="showCommConvos" color="green">mdi-chat</v-icon>
                    <v-tooltip activator="parent" location="top">View convos on this contact</v-tooltip>
                  </div>
                  <div v-if="can_manual_tagging" style="display: inline;">
                    <v-icon size="15" @click="toggleTagPopup" style="margin-left: 5px" color="red">mdi-tag-plus</v-icon>
                    <v-tooltip activator="parent" location="top">Add Tag to Contact</v-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="current_contact.contact_id != 'family'" style="grid-area: 1/1/1/1; justify-self: end;">
            <v-btn-toggle v-if="!isMobile" borderless>
              <!-- cell phone button / endpoint button -->
              <v-tooltip v-if="contact.ph1 && contact.ph1" location="bottom" :text="phoneFormat(contact.ph1)">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" class="ml-2" color="green darken 1"
                    @click="phoneCall(contact.full_name, contact.ph1)">mdi-cellphone</v-icon>
                </template>
              </v-tooltip>
              <!-- home phone button -->
              <v-tooltip v-if="contact.ph2 && contact.ph2" location="bottom" :text="phoneFormat(contact.ph2)">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" class="ml-2" color="green darken 1"
                    @click="phoneCall(contact.full_name, contact.ph2)">mdi-home</v-icon>
                </template>
              </v-tooltip>
              <!-- work phone button -->
              <v-tooltip v-if="contact.ph3 && contact.ph3" location="bottom" :text="phoneFormat(contact.ph3)">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" class="ml-2" color="green darken 1"
                    @click="phoneCall(contact.full_name, contact.ph3)">mdi-briefcase</v-icon>
                </template>
              </v-tooltip>
              <v-tooltip v-if="contact.email" location="bottom" :text="contact.email">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" class="ml-2" color="green darken-1" @click="activateEmailMode">
                    mdi-email
                  </v-icon>
                </template>
              </v-tooltip>
            </v-btn-toggle>
            <v-menu v-else location="bottom center">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props" color="primary">mdi-phone-outline</v-icon>
              </template>
              <v-list>
                <v-list-item v-if="contact.ph1 && contact.ph1">
                  <v-icon class="ml-2" color="green darken 1"
                    @click="phoneCall(contact.full_name, contact.ph1)">mdi-cellphone</v-icon>
                </v-list-item>
                <v-list-item v-if="contact.ph2 && contact.ph2">
                  <v-icon class="ml-2" color="green darken 1"
                    @click="phoneCall(contact.full_name, contact.ph2)">mdi-home</v-icon>
                </v-list-item>
                <v-list-item v-if="contact.ph3 && contact.ph3">
                  <v-icon class="ml-2" color="green darken 1"
                    @click="phoneCall(contact.full_name, contact.ph3)">mdi-briefcase</v-icon>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-icon v-if="isMobile && !isUser" @click="changeRightPanelStatus(true)" size="25">mdi-dots-vertical</v-icon>
          </div>
        </div>
        <v-divider class="mt-1"></v-divider>
        <v-progress-linear v-if="conversation_loading" color="blue-darken-3" indeterminate></v-progress-linear>
      </div>
    </div>
    <!-- This row holds the messenger header -->
    <!-- This row holds the message chat virtual scroller -->
    <div v-show="!showFrontdeskSettings && !getThreadVisibility" style="flex: 10 10; position: relative">
      <div
        v-show="allConversations?.length"
        style="position: absolute; top: 0; left: 0; bottom: 0; right: 0"
      >
      <div v-if="scrollDate" class="floating-date">
        {{ scrollDate }}
      </div>
        <DynamicScroller
          :items="renderConversations"
          key-field="comm_participant_id"
          style="height: 100%"
          :buffer="20000"
          ref="scroller"
         :min-item-size="54"
          @scroll="handleScroll"
        
        >
          <template v-slot="{ item, index, active }">
            <DynamicScrollerItem :item="item" :active="active" :size-dependencies="[
              item.message,
              item.tagRemovalNotes,
            ]" :data-index="index" :data-active="active">
              <FDMessage :message="item" :prev="index === 0 ? null : renderConversations[index - 1]" :index="index"
                :active="active" :contact="getHeaderInfo(item.contact_id)" />
            </DynamicScrollerItem>
          </template>
        </DynamicScroller>
        <transition name="slide-up-down">
    <v-btn   v-if="showTagArrow"
     class="arrow-bottom"
      @click="tagconversation"
      icon
      size="small"
      color="warning"
      variant="outlined"
    >
      <v-icon size="18">mdi-hand-pointing-up</v-icon>
    </v-btn>
</transition>
<transition name="slide-up-down">
          <v-icon
            v-if="showScrollDownArrow && !showTagArrow"
            class="arrow-bottom"
            size="27"
            @click="scrollToBottom"
          >
            mdi-arrow-down-thin-circle-outline
          </v-icon>
        </transition>
      </div>
    </div>
    <!-- this row holds the message box -->
    <div v-show="!showFrontdeskSettings && !getThreadVisibility" style="flex: 1 1; position: relative">
      <v-overlay absolute :value="current_contact && !current_contact.contact_id" :opacity="0.08"></v-overlay>
      <FDMessengerBox ref= "messengerBox" v-if="current_contact.contact_id" :current_contact="current_contact" :contact="contact"
        :mostRecentNumber="mostRecentCall" :lastReceivedMsg="lastReceivedMsg" @reminderClicked="reminderClicked()" />
    </div>
    <!-- It will show Tag Settings -->
    <div v-if="showFrontdeskSettings && !getThreadVisibility" style="flex: 10 10; position: relative; overflow-y:auto;"
      @touchstart.passive.stop @touchmove.passive.stop @touchend.passive.stop>
      <div style="position: absolute; top: 0; left: 0; bottom: 0; right: 0">
        <FrontDeskSettings @closeTagSettings="showFrontdeskSettings = false" :isType="isTypeSetting"
          :isTag="isTagSetting" :isMessageTemplate="isMessageTemplateSetting" />
      </div>
    </div>
    <div v-show="getThreadVisibility" class="email-panel">
      <div class="email-container">
        <Email v-if="getEmails && getEmails.length" :subject="getEmails[0].subject" :Emails="getEmails"/>
      </div>
    </div>
  </div>
</template>

<script>
import FDMessage from "@/components/FrontDesk/FDMessage";
import FDMessengerBox from "@/components/FrontDesk/FDMessengerBox";
import MiscService from "@/services/miscService";
import ConvoService from "@/services/convoService";
import OdService from "@/services/odService";
import ContactPopup from "@/components/Avatar/ContactPopup";
import UnknownPopup from "@/components/Avatar/UnknownPopup";
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import EventBus from "@/eventBus";
import { phoneFormat, phoneFormatTitle } from "@/util/util";
import FrontDeskSettings from "../AdminSettings/FrontDeskSettings.vue";
import TagPopup from "../CustomPopup.vue";
import { differenceInHours, parseISO } from 'date-fns';
import dayjsMixin from "@/mixins/dayjsMixin";
import Email from "@/views/Email.vue";
import { ALERT } from "../../constants/alert";

export default {
  name: "Messenger",
  components: {
    FDMessage,
    FDMessengerBox,
    ContactPopup,
    UnknownPopup,
    FrontDeskSettings,
    TagPopup,
    Email
  },
  props: {
    allConversations: { type: Array },
    contact: { type: Object, default: null },
  },
  mixins: [dayjsMixin],
  emits: [],
  data() {
    return {
     scrollDate: null,
     scrollDateTimer: null,
      toggleConvo: false,
      convoReference: null,
      mostRecentCall: "",
      highlightedItem: null,
      highlightedComm: null,
      lastReceivedMsg: null,
      showTagPopup: false,
      showFrontdeskSettings: false,
      isTypeSetting: false,
      showFamilyDialog: false,
      familyMembers: [],
      hoveredMember: null,
      selectedIndex: null,
      selectedAllFamilyButton: false,
      familyHead: null,
      showoptions : false,
      isTagSetting : false,
      showScrollDownArrow : false,
        tagJumpIndex: 0,
      reliability: null,
      insurance: null
    };
  },
  computed: {
    ...mapGetters("frontdesk", ["getconversationtag","getshowconversationtagarrow","current_contact","odFilterSelectedValue","getOdTag","isODFilterContact","isUser","getAllConversations","conversation_loading","isScrollerVisible","getThreadVisibility", "getEmails","getLabCaseNum"]),
    ...mapGetters(['userId']),
    ...mapGetters(['clientId']),
    ...mapGetters(['isODEnabled']),
    ...mapState(['contactState']),
    ...mapGetters("people", ["contactsHash", "getHeaderInfo", "getContactColor", "getFamilyMembers"]),
    ...mapGetters("tags", ["tagsHashnew", "tags", "tagsHash", "can_manual_tagging"]),
    ...mapGetters("window", ["isMobile"]),
    attachedTagIds() {
      return this.current_contact.tag_id || [];
    },
filteredTags() {
  const contactTagIds = this.current_contact?.tag_id || [];

  const unselected = this.tags.filter((tag) => !contactTagIds.includes(tag.tag_id) && !tag.unlist &&  !tag.enable_auto);

  return unselected;
},
    showTagArrow() {
      return (this.getshowconversationtagarrow === true &&Array.isArray(this.getconversationtag) &&this.tagJumpIndex < this.getconversationtag.length);
    },
    // Tag-removal system messages carry a ref_conversation_id pointing at the
    // message they refer to. Rather than rendering a second, separate row
    // right after that message (which duplicated the removal's own timestamp
    // out of context), attach the caption(s) directly onto the referenced
    // message as tagRemovalNotes — FDMessage.vue renders those inside the
    // message's own box, below its note. The removal's own row, at its real
    // chronological position, is untouched — this only replaces the second,
    // inline-duplicate rendering.
    renderConversations() {
      const list = this.allConversations;
      if (!Array.isArray(list) || !list.length) return list;

      const refsByTarget = {};
      for (const item of list) {
        if (item.is_system_message && item.ref_conversation_id) {
          (refsByTarget[item.ref_conversation_id] ||= []).push(item);
        }
      }
      if (!Object.keys(refsByTarget).length) return list;

      return list.map(item => {
        const refs = refsByTarget[item.comm_participant_id];
        return refs ? { ...item, tagRemovalNotes: refs.map(r => ({ message: r.message, date: r.date })) } : item;
      });
    }
  },
  watch: {
  getconversationtag(newVal) {
      if (!Array.isArray(newVal) || newVal.length === 0) {
        this.tagJumpIndex = 0;
        this.setshowconversationtagarrow(false);
      } else {
      this.tagJumpIndex = 0;
      this.setshowconversationtagarrow(true);
    }
  },

  "current_contact.contact_id"() {
    this.tagJumpIndex = 0;
    this.fetchReliability();
    this.fetchInsurance();
  },
    "allConversations.length": function () {
     
      this.getMostRecentCall();
      EventBus.$emit("new_comm");
    },
    "contactState.contact_id": function (newID) {
      if (newID) {
        this.showFrontdeskSettings = false;
        this.showTagPopup = false;
        this.showScrollDownArrow = false;
        } 
    },
    "current_contact":{
    
      handler(newCall) {
        if(!this.isUser){ 
        if (newCall && newCall.contact_id && newCall.contact_id != "family") {
          this.familyMembers=[];
          if(newCall.family==0){
            this.familyHead = this.contactsHash[newCall.contact_id];
          }
          else{
            let familyMembersListContactId = this.getFamilyMembers(this.contactsHash[newCall.contact_id]);
            for (let contact_id of familyMembersListContactId) {
              const contact = this.getHeaderInfo(contact_id);
              this.familyMembers.push(contact);
              if(contact.contact_id == contact.family){
                this.familyHead = contact;
              }
            }
          }
          this.selectedIndex = this.familyMembers.findIndex(
            (member) => member.contact_id == newCall.contact_id
          );
          this.selectedAllFamilyButton = false;
        }
      }else{
        this.showFamilyDialog = false
        this.familyMembers= []
        this.hoveredMember= null
        this.selectedIndex= null
        this.selectedAllFamilyButton= false
        this.familyHead= null
      }
    },
    "current_contact": {
      immediate: true, // Ensures it runs as soon as `call` is available
      handler(newCall) {
        if (!this.isUser) {
          if (newCall && newCall.contact_id && newCall.contact_id != "family") {
            this.familyMembers = [];
            if (newCall.family == 0) {
              this.familyHead = this.contactsHash[newCall.contact_id];
            }
            else {
              let familyMembersListContactId = this.getFamilyMembers(this.contactsHash[newCall.contact_id]);
              for (let contact_id of familyMembersListContactId) {
                const contact = this.getHeaderInfo(contact_id);
                this.familyMembers.push(contact);
                if (contact.contact_id == contact.family) {
                  this.familyHead = contact;
                }
              }
            }
            this.selectedIndex = this.familyMembers.findIndex(
              (member) => member.contact_id == newCall.contact_id
            );
            this.selectedAllFamilyButton = false;
          }
        } else {
          this.showFamilyDialog = false
          this.familyMembers = []
          this.hoveredMember = null
          this.selectedIndex = null
          this.selectedAllFamilyButton = false
          this.familyHead = null
        }
      },
    },
    contactState() {
      this.showFrontdeskSettings = false;
    }
  }
},

  created() {
    EventBus.$on("highlightConvoComm", (convo) => {
      this.highlightedItem = "comm";
      this.highlightedComm = convo;
      this.scrollToReference(convo.convo_references[0].conversation_id);
    });

    EventBus.$on("highlightContact", () => {
      this.highlightedItem = "contact";
    });

    EventBus.$on("clearHighlight", () => {
      this.highlightedItem = null;
      this.highlightedComm = null;
    });

    EventBus.$on("submitConvo", async (content, comm) => {
       let data = {
        message: content,
        contact_id: this.current_contact.contact_id,
        conversation_id: comm,
         type:'internal'
      };
      if (this.getLabCaseNum) {
        data.LabCaseNum = this.getLabCaseNum;
      }
      try {
        await ConvoService.createInternalConvo(data);
        this.setLabCaseNum(null);
        EventBus.$emit("alert", {
          message: "Internal Convo Created Successfully",
          type: ALERT.SUCCESS,
        });
      } catch (error) {
        EventBus.$emit("alert", {
          message: "Failed To Create Internal Convo",
          type: ALERT.ERROR,
        });
        console.error(error);
      }
    });
    EventBus.$on("scroll-to-reference", (payload) => {
      if (payload && typeof payload === "object") {
        this.scrollToReference(payload.id, payload.highlight);
      } else {
        this.scrollToReference(payload, false);
      }
    });
    if (this.allConversations && this.allConversations.length > 0) this.getMostRecentCall();
  },

  methods: {
    phoneFormat,
    ...mapMutations(["setContact"]),
    ...mapMutations(['changeRightPanelStatus']),
    ...mapMutations("frontdesk", ["setshowconversationtagarrow","change_contact", "setAllConversations","updateIsScrollerVisible","setLabCaseNum"]),
    ...mapMutations("convos", ["setInternalConvos"]),
    ...mapGetters("people", ["contactTypes"]),
    ...mapActions("tags",["addTagforContact","removeTagForContact"]),
    ...mapActions("frontdesk", ["searchConversation","getMoreConversationsTop","getMoreConversationsBottom","getConversations"]),
    phoneFormatTitle,
    async fetchReliability() {
      this.reliability = null;
      const contact_id = this.current_contact?.contact_id;
      if (!this.isODEnabled || !contact_id || contact_id === 'family') return;
      try {
        const res = await OdService.getContactReliability(contact_id);
        this.reliability = res?.data?.data || null;
      } catch (error) {
        console.error(error);
        this.reliability = null;
      }
    },
    async fetchInsurance() {
      this.insurance = null;
      const contact_id = this.current_contact?.contact_id;
      if (!this.isODEnabled || !contact_id || contact_id === 'family') return;
      try {
        const res = await OdService.getContactInsurance(contact_id);
        this.insurance = res?.data?.data || null;
      } catch (error) {
        console.error(error);
        this.insurance = null;
      }
    },
    reliabilityColor(label) {
      switch (label) {
        case 'Reliable': return 'green';
        case 'Some disruptions': return 'amber-darken-2';
        case 'Frequently unreliable': return 'red';
        default: return 'grey';
      }
    },
    getMostRecentCall() {
      let recentInbound = null;
      let recentOutbound = null;
      this.lastReceivedMsg = null;
      for (let i = this.allConversations.length - 1; i >= 0; i--) {
        if (
          (this.allConversations[i].comm_direction == "incoming" ||
            this.allConversations[i].comm_direction == "inbound") &&
          this.isTextable(this.allConversations[i])
        ) {
          if (recentInbound == null) {
            recentInbound = this.allConversations[i];
          }
          if (this.allConversations[i].comm_direction == "incoming") {
            this.lastReceivedMsg = this.allConversations[i];
          }
        } else if (
          this.isTextable(this.allConversations[i]) &&
          recentOutbound == null
        ) {
          recentOutbound = this.allConversations[i];
        }
      }
      this.mostRecentCall =
        recentInbound != null
          ? recentInbound.phone_num
          : recentOutbound != null
            ? recentOutbound.phone_num
            : null;
    },
    isTextable(message) {
      if (message || !this.current_contact) return false;
      return (
        (message.phone_num == this.current_contact.ph1 && this.current_contact.textable1 == 1) ||
        (message.phone_num == this.current_contact.ph2 && this.current_contact.textable2 == 1) ||
        (message.phone_num == this.current_contact.ph3 && this.current_contact.textable3 == 1)
      );
    },
    toggleSize(index) {
      this.selectedIndex = index;
      this.selectedAllFamilyButton = false;
    },
    phoneCall(name, number) {
      let tagId = 0;
      if (this.odFilterSelectedValue && this.getOdTag && this.getOdTag.enable_auto && this.isODFilterContact(this.current_contact.contact_id)) {
        tagId = this.getOdTag.tag_id;  // sending tag_id for conversation auto tag 
      }
      EventBus.$emit("call-event", { name, number, tagId });
    },
      activateEmailMode() {
    // Find the index of the email option in deviceIcons
    const emailIndex = this.$refs.messengerBox.deviceIcons.findIndex(
      icon => icon.icon === 'mdi-email'
    );
    
    if (emailIndex !== -1) {
      // Trigger the device change in the messenger box
      this.$refs.messengerBox.newDeviceClicked(emailIndex);
    }
  },
    scrollToBottom() {
      console.log("start of scrollToBottom");
      this.$nextTick(() => {
        if (!this.$_scrollingToBottom) {
          this.scrollToPosition(999999999);
          this.$_scrollingToBottom = true;
        }
      });
      console.log("end of scrollToBottom");
    },
    reminderClicked() {
      this.showInternalConvo();
    },
    createInternalConvo() {
      this.changeRightPanelStatus(true);
      setTimeout(() => {
        EventBus.$emit("createConvo", null);
      }, 0);
    },
    showCommConvos() {
      this.changeRightPanelStatus(true);
      setTimeout(() => {
        EventBus.$emit("showContactConvos");
      }, 0);
    },
    showInternalConvo() {
      this.changeRightPanelStatus(true);
      setTimeout(() => {
        EventBus.$emit("populateRightPanel1");
      }, 0);
    },

    scrollToPosition(position) {
      console.log("start of scrollToPosition");
      if (!this.$refs.scroller) return;
      const scroller = this.$refs.scroller.$el;
      scroller.scrollTop = position;
      requestAnimationFrame(() => {
        scroller.scrollTop = position;
        setTimeout(() => {
          scroller.scrollTop = position;
          this.$_scrollingToBottom = false;
        }, 100);
      });

      console.log("end of scrollToPosition");
    },

    toggleTagPopup() {
      if (this.isMobile) {
        setTimeout(() => {
          this.showoptions = false;
          this.showTagPopup = !this.showTagPopup
        }, 200);
      } else {
        this.showTagPopup = !this.showTagPopup
      }
    },
    async addTagToContact(tag_id) {
      try {
        this.showTagPopup = false;
        let data = { contact_id: this.contactState.contact_id, tag_id: tag_id }
        await this.addTagforContact(data);
      } catch (error) {
        console.error(error);
      }
    },
    async remove_TagForContact(tag_id) {
      try {
        let data = { contact_id: this.contactState.contact_id, tag_id: tag_id };
        await this.removeTagForContact(data);
      } catch (error) {
        console.error(error);
      }
    },
    handleAllMouseLeave() {
      if (this.selectedIndex !== 'all') {
        this.hoveredMember = null;
      }
    },
    async viewFamilyMember(member) {
      const contact = this.contactsHash[member.contact_id];
      const contactId = contact.contact_id;
      try {
        this.change_contact({
          ...contact,
          tag_id: contact.tags
        });
        this.setContact(contact);
        await this.getConversations({contact_id : contactId});
        EventBus.$emit("scroll-bottom");
      } catch (error) {
        console.error(error);
      }
      this.updateRightPanel(contactId);
    },
    async viewAllFamilyConvos() {
      try {
        let memberIds = [];
        for (const member of this.familyMembers) {
            const contact = this.contactsHash[member.contact_id];
            const contactId = contact.contact_id;
            memberIds.push(contactId);
        }
        this.change_contact({ memberIds : memberIds ,contact_id: 'family' });
        this.updateRightPanel('forFamily');
        await this.getConversations({ memberIds : memberIds });
        EventBus.$emit("scroll-bottom");
      } catch (error) {
        console.error(error);
      }
    },
    async updateRightPanel(contact_id, getClosed = false) {
      EventBus.$emit("update-Reminder", { reminder_count: 0, initial: true });
      let reminder_count = 0;
      if (contact_id == 'forFamily') {
        let allconvos = [];
        for (const member of this.familyMembers) {
          let _contact_id = parseInt(member.contact_id);
          let convos = [];
          if (getClosed) {
            convos = await ConvoService.getClientClosedInternalConvos(_contact_id);
          } else {
            convos = await ConvoService.getClientInternalConvos(_contact_id);
          }
          convos = convos?.data;
          convos.forEach((convo) => {
            let remainingHrs;
            if (convo.userReminder) {
              const givenDate = parseISO(convo.userReminder.reminder_date);
              const now = new Date();
              remainingHrs = differenceInHours(givenDate, now);
              convo.remaining_hr = remainingHrs;
            }
            else {
              convo.remaining_hr = null;
            }
          })
          allconvos.push(...convos);
        }
        allconvos.sort((a, b) => {
          if (a.remaining_hr === null) return 1;  // If a is null, push it to the end
          if (b.remaining_hr === null) return -1; // If b is null, push it to the end
          return a.remaining_hr - b.remaining_hr; // Otherwise, compare the values
        });
        let contact = this.contactsHash[parseInt(this.familyHead.contact_id)];
        this.setContact(contact);
        this.setInternalConvos(allconvos);
        EventBus.$emit(
          "populateRightPanel",
          { contact_id: this.familyHead.contact_id },
          allconvos
        );
        return;
      }
      let _contact_id = parseInt(contact_id);
      let contact = this.contactsHash[contact_id];
      let convos=[];
      if(getClosed){
        convos = await ConvoService.getClientClosedInternalConvos(_contact_id);
      } else {
        convos = await ConvoService.getClientInternalConvos(_contact_id);
      }
      convos = convos?.data;
      convos.forEach((convo) => {
        let remainingHrs;
        if (convo.userReminder) {
          const givenDate = parseISO(convo.userReminder.reminder_date);
          const now = new Date();
          remainingHrs = differenceInHours(givenDate, now);
          convo.remaining_hr = remainingHrs;
          if (convo.userReminder.reminder_for_who == this.userId) {
            reminder_count = reminder_count + 1;
          }
        }
        else {
          convo.remaining_hr = null;
        }
      })
      convos.sort((a, b) => {
        if (a.remaining_hr === null) return 1;  // If a is null, push it to the end
        if (b.remaining_hr === null) return -1; // If b is null, push it to the end
        return a.remaining_hr - b.remaining_hr; // Otherwise, compare the values
      });

      this.setInternalConvos(convos);
      EventBus.$emit(
        "populateRightPanel",
        contact ? contact : { phone_num: contact_id },
        convos
      );
      EventBus.$emit("update-Reminder", { reminder_count: reminder_count, initial: true });// initial reminder count
    },
    scrollToReference(refIndex, highlightItem = true) {
      const index = this.renderConversations.findIndex(item => item.comm_participant_id === refIndex);
      if (index === -1) {
        EventBus.$emit("reference-not-found", refIndex);
        return;
      }
      // Use DynamicScroller's own height-aware scrollToItem (not a raw DOM
      // scrollIntoView) so the recycler's internal size/position bookkeeping
      // stays consistent with where we actually scroll. Deliberately NOT
      // forceUpdate(true) here: in the (default, modern-browser) ResizeObserver
      // mode, DynamicScrollerItem never re-registers for the 'vscroll:update'
      // event forceUpdate emits (see vue-virtual-scroller's DynamicScrollerItem
      // `created()`, gated behind `if (!this.vscrollResizeObserver)`) — so
      // forceUpdate(true)'s cache clear (`vscrollData.sizes = {}`) zeroes out
      // every already-measured row's height with nothing to repopulate it
      // until that row's own ResizeObserver happens to refire, which it won't
      // if its DOM size hasn't actually changed. That's exactly what caused
      // already-rendered rows (e.g. media messages) to collapse to 0 height
      // and overlap the rows after them. The repeated scrollToItem calls
      // below (mirroring scrollToPosition's settle pattern) are what actually
      // matter here — DynamicScrollerItem measures its own height correctly
      // on mount via computeSize()/offsetHeight, no manual cache-busting needed.
      const scroller = this.$refs.scroller;
      this.$nextTick(() => {
        if (scroller) scroller.scrollToItem(index);
        requestAnimationFrame(() => {
          if (scroller) scroller.scrollToItem(index);
          setTimeout(() => {
            if (scroller) scroller.scrollToItem(index);
            if (highlightItem) {
              const element = document.getElementById(`bubble-${refIndex}`);
              if (element) {
                element.style.backgroundColor = 'yellow';
                setTimeout(() => {
                  element.style.backgroundColor = ''; // revert to original or default background color
                }, 2000);
              }
            }
          }, 100);
        });
      });
    },
    goBack() {
      EventBus.$emit("back-to-FDLeft");
    },
    openOptions() {
      this.showoptions = true;
    },
    closeOptions() {
      setTimeout(() => {
        this.showoptions = false;
      }, 2000);
    },
async handleScroll(event) {
  const scrollerEl = event.target;
  const { scrollTop, scrollHeight, clientHeight } = scrollerEl;

  /* ===========================
     TOP – Load older messages
  ============================ */
  const isTop = scrollTop === 0;

  if (isTop && !this.conversation_loading) {
    const scroller = this.$refs.scroller;
    const prevScrollHeight = scroller.$el.scrollHeight;

    await this.getMoreConversationsTop();

          this.$nextTick(() => {
            // Maintain scroll position after new messages are prepended
            const val = 70; // Adjust this value as needed. it shows next message from top
            const newScrollHeight = scroller.$el.scrollHeight;
            const value = (newScrollHeight - prevScrollHeight) - val;
            this.scrollToPosition(value);
          });
      }
      
      const isBottom = scrollTop + clientHeight >= scrollHeight - 1; 

      if(isBottom && !this.conversation_loading){
        console.log("Reached Bottom");
        await this.getMoreConversationsBottom();
      }

      if (scrollHeight > clientHeight && !this.isScrollerVisible) {
        this.updateIsScrollerVisible(true);
      }
      const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);
  this.showScrollDownArrow = distanceFromBottom > 200;

  this.$nextTick(() => {
    const container = this.$refs.scroller.$el;
    const items = container.querySelectorAll("[data-index]");
    for (const el of items) {
      const rect = el.getBoundingClientRect();
      const parentRect = container.getBoundingClientRect();
      if (rect.top >= parentRect.top) {
        const index = Number(el.dataset.index);
        const msg = this.allConversations[index];

        if (msg?.date) {
          this.scrollDate = this.getFloatingDate(msg.date);
        }
        break;
      }
    }

    clearTimeout(this.scrollDateTimer);
    this.scrollDateTimer = setTimeout(() => {
      this.scrollDate = null;
    }, 1200);
  });
},
getFloatingDate(date) {
  const msgDate = this.dayjs(date).startOf("day");
  const today = this.dayjs().startOf("day");
  const yesterday = this.dayjs().subtract(1, "day").startOf("day");

  if (msgDate.isSame(today)) return "Today";
  if (msgDate.isSame(yesterday)) return "Yesterday";

  return msgDate.format("DD MMM YYYY");
},

async tagconversation() {
  const data = this.getconversationtag;

  if (!Array.isArray(data) || !data.length) {
    console.warn("No conversation tag data found");
    this.setshowconversationtagarrow(false);
    return;
  }

  // Stop when all tagged convos are visited
  if (this.tagJumpIndex >= data.length) {
    this.tagJumpIndex = 0;
    this.setshowconversationtagarrow(false);
    return;
  }

  const { timestamp, conversation_id } = data[this.tagJumpIndex];

  console.log("Jumping to tagged convo:", this.tagJumpIndex,conversation_id,timestamp);

  await this.searchConversation({timestamp,contact_id: this.current_contact.contact_id });

  this.$nextTick(() => {
    this.scrollToReference(conversation_id);
  });

  this.tagJumpIndex++;
}
  },

  mounted() {
    this.fetchReliability();
    this.fetchInsurance();

    EventBus.$on("open-tag-settings", () => {
      this.isTypeSetting = false;
      this.showFrontdeskSettings = true;
      this.showTagPopup = false;
      this.isTagSetting = true;
      this.isMessageTemplateSetting = false;
    })
    EventBus.$on("open-contact-type-settings", () => {
      this.showFrontdeskSettings = true;
      this.isTypeSetting = true;
      this.isTagSetting = false;
      this.isMessageTemplateSetting = false;
      if (this.isMobile) {
        EventBus.$emit("back-to-FDLeft"); // if it is mobile then it will toggle the left panel and open setting in center panel
      }
    })
    EventBus.$on("open-message-template-settings", () => {
      this.showFrontdeskSettings = true;
      this.isTypeSetting = false;
      this.isTagSetting = false;
      this.isMessageTemplateSetting = true;
    })
    EventBus.$on("update-InternalConvos", (contact_id, getClosed = false) => {
      this.updateRightPanel(contact_id, getClosed);
    });
    EventBus.$on("scroll-bottom",()=>{
      this.scrollToBottom();
    });
  },
  beforeUnmount() {
    EventBus.$off("highlightConvoComm");
    EventBus.$off("highlightContact");
    EventBus.$off("clearHighlight");
    EventBus.$off("submitConvo");
    EventBus.$off("open-tag-settings");
    EventBus.$off("update-InternalConvos");
    EventBus.$off("open-message-template-settings");
    EventBus.$off("open-contact-type-settings");
    EventBus.$off("scroll-bottom");
  },

};
</script>

<style scoped>
.outlined {
  background-color: var(--v-highlighted-base);
  border: 1px solid gray;
}

.rounded {
  border-radius: 2px;
}

.ml-2 {
  margin-left: 2px;
}

.tag-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.add-tag-icon {
  margin-right: 16px;
  cursor: pointer;
}

.shared-overlay {
  position: absolute;
  z-index: 1;
  top: 23%;
  left: 45%;
}

.circle-style {
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: 15px;
  border: 2px solid transparent;
}

.avatar-text {
  font-size: 0.6rem;
  color: black;
}

.tooltip-box {
  position: absolute;
  top: -22px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.75rem;
  color: white;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 3px 5px;
  border-radius: 5px;
  max-width: 140px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tooltip-box-all {
  position: absolute;
  margin-top: -22px;
  left: 67%;
  transform: translateX(-50%);
  font-size: 0.75rem;
  color: white;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 3px 5px;
  border-radius: 5px;
  max-width: 140px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.icon-container {
  display: flex;
  justify-content: center;
  margin-top: 5px;
}

/* When hovered, the circle gets a black border */
.hovered-circle {
  border: 2px solid black;
}

/* When selected, the border becomes black */
.selected-circle {
  border: 2px solid black !important;
  margin-left: -8px !important;
  margin-right: -8px !important;
}

.all-selected-circle {
  border: 2px solid black !important;
}

/* Spacing for the ALL button */
.all-circle-container {
  cursor: pointer;

}

.mx-1 {
  margin-right: 4px !important;
  margin-left: 20px !important;
}

.email-panel {
  flex: 10 10;
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.email-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 1em;
  background: var(--v-surface);
  box-shadow: 4px 0 8px rgba(0, 0, 0, 0.1);
}
.arrow-bottom{
  position: absolute;
  bottom: 8px;
  cursor: pointer;
}

.slide-up-down-enter-active,
.slide-up-down-leave-active {
  transition: all 0.4s ease;
}

.slide-up-down-enter-from {
  opacity: 0;
  transform: translateY(20px);
}
.slide-up-down-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.slide-up-down-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.slide-up-down-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
.floating-date {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  background: #e5e5e5;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  color: #555;
  z-index: 1000;
  pointer-events: none;
}

</style>
